const STANDARD = 1;
const MASTER = 2;
const ASSOCIATE = 3;

export default {
  STANDARD, MASTER, ASSOCIATE
};
